__turbopack_context__.v({
  "gridItem": "DevGrid-module__SRIOoW__gridItem",
  "root": "DevGrid-module__SRIOoW__root",
  "subgrid": "DevGrid-module__SRIOoW__subgrid",
});
